import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { Currency, PurchaseOrderStatus } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

import { PurchaseOrderModel } from './purchase-orders.model';

export type PurchaseOrdersState = EntityState<
  RequireSome<Partial<PurchaseOrderModel>, 'id'> & {
    currency: Currency;
    organization_id: null | string;
    organization_name: null | string;
    paid_amount: null | number;
    po_report_amount: null | number;
    po_report_invoiced_amount: null | number;
    po_report_status: null | PurchaseOrderStatus;
    received_amount: null | number;
  },
  string
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'purchase-orders' })
export class PurchaseOrdersStore extends EntityStore<PurchaseOrdersState> {
  constructor() {
    super({});
  }
}
